import logo from './logo.svg';
import './App.css';
import store from './store';
import {Provider} from 'react-redux';
import Navheader from './Components/Navheader';
import Background from './Components/Background';
import Element from './Components/Element';
import styles from './Components/styles.module.scss';
import Button from './Components/Button';
import Card from './Components/Card';
import Footer from './Components/Footer';
import Vid from './Components/Vid';
import PasswordInput from './Components/PasswordInput';
import Modal from './Components/Modal';
import { useState } from 'react';
function Updates(props) {
  const gameArray = props.games;
  const horrorGameArray = props.horrorGames;
  const gameCardsArray = props.gameCards;


  return (

    <div className="App"
    style={{
      width: '100%',
      background:'black',
      overflowX: "hidden"
    }}>
    <Background halloween={props.halloween} xmas={props.xmas}></Background> 
        <Element halloween={props.halloween} xmas={props.xmas} height={"10P"} background={2}></Element>
    <Element halloween={props.halloween} xmas={props.xmas} height={"90P"} background={9} flexColumn={true}>
    <div className={`${styles[`h1`]}`}>Modified Nevrycards</div>
    <div className={`${styles[`h2`]}`}>Enhanced User Experience</div>
    <div className={`${styles[`h2`]}`}>Enhanced Interface</div>
    <div className={`${styles[`h2`]}`}>More in progress...</div>
    </Element>



       
                        
                                 
    <Footer halloween={props.halloween} xmas={props.xmas}></Footer>

        

    <Navheader halloween={props.halloween} xmas={props.xmas} games={gameArray} horrorGames={horrorGameArray}></Navheader>
   
    </div>

    
  );
}

export default Updates;
